document.addEventListener('DOMContentLoaded', function() {
  const storeTrigger = document.querySelector('.store-trigger');
  const storeMenuWrapper = document.querySelector('.store-menu-wrapper');

  if (storeTrigger && storeMenuWrapper) {
    // For mobile: toggle menu on click
    storeTrigger.addEventListener('click', function(e) {
      if (window.innerWidth < 700) {
        e.preventDefault();
        e.stopPropagation();
        storeMenuWrapper.classList.toggle('is-open');
      }
    });

    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (window.innerWidth < 700 && 
          !storeMenuWrapper.contains(e.target) && 
          !storeTrigger.contains(e.target)) {
        storeMenuWrapper.classList.remove('is-open');
      }
    });
  }
}); 